import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/Button';
export const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-219">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 100
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 100
    }} className="fixed bottom-0 left-0 w-full z-40 p-4 bg-gradient-to-t from-night-900 via-night-900/90 to-transparent md:bg-none md:bottom-6 md:right-6 md:left-auto md:w-auto md:p-0" data-id="element-220">
          <Button href="#compra" className="w-full md:w-auto shadow-[0_0_30px_rgba(245,158,11,0.3)]" data-id="element-221">
            QUIERO APAGAR LA CABEZA Y DORMIRME
          </Button>
        </motion.div>}
    </AnimatePresence>;
};